export const PROGRESS_STATUS_URGENT = 'urgent'
export const PROGRESS_STATUS_WARNING = 'warning'
export const PROGRESS_STATUS_ONTRACK = 'on-track'
export const PROGRESS_STATUS_DELIVERED = 'delivered'
export const PROGRESS_STATUS_UNKNOWN = 'unknown'
export const ORDER_PROGRESS_STATUS_HAS = [
  PROGRESS_STATUS_URGENT,
  PROGRESS_STATUS_WARNING,
  PROGRESS_STATUS_ONTRACK,
  PROGRESS_STATUS_DELIVERED,
  PROGRESS_STATUS_UNKNOWN,
]

export const PBF_QUERY_KEY = {
  PBF_ORDERS: 'PBF_ORDERS',
  GET_ORDER_SUMMARY: 'GET_ORDER_SUMMARY',
  COMPANY_SETTING_HIDE_ORDER_PROP: 'COMPANY_SETTING_HIDE_ORDER_PROP',
  GET_ORDER_SETTING: 'GET_ORDER_SETTING',
  INSPECTION_DETAIL: 'INSPECTION_DETAIL',
  GET_REPORT_DATA: 'GET_REPORT_DATA',
  GET_ORDER_ITEM_SETTING: 'GET_ORDER_ITEM_SETTING',
  GET_INSPECTION_COMMENTS: 'GET_INSPECTION_COMMENTS',
  GET_ORDER_SEQUENTIAL_PROPERTY: 'GET_ORDER_SEQUENTIAL_PROPERTY',
  GET_REPORT_SETTING: 'GET_REPORT_SETTING',
  PBF_ORDERS_ADVANCE_SUMMARY: 'PBF_ORDERS_ADVANCE_SUMMARY',
  GET_COMPANY_SETTING_AUTO_GENERATE_PROP:
    'GET_COMPANY_SETTING_AUTO_GENERATE_PROP',
  GET_COMPANY_SETTING_ADVANCE_FILTER_CUSTOM:
    'GET_COMPANY_SETTING_ADVANCE_FILTER_CUSTOM',
  GET_ORDER_CUSTOM_COLUMNS: 'GET_ORDER_CUSTOM_COLUMNS',
  ORDER_EXPORT_SETTING: 'ORDER_EXPORT_SETTING',
  PRODUCT_EXPORT_SETTING: 'PRODUCT_EXPORT_SETTING',
  GET_FCCA_RATING_SETTING: 'GET_FCCA_RATING_SETTING',
  GET_HIDDEN_BLOCK_SETTING: 'GET_HIDDEN_BLOCK_SETTING',
  GET_REPORT_COMBINED_DEFECTS_SETTING: 'GET_REPORT_COMBINED_DEFECTS_SETTING',
  GET_PRODUCTION_STATUS_SETTING: 'GET_PRODUCTION_STATUS_SETTING',
  GET_COMPANY_SETTING_HAS_SUPPLIER: 'GET_COMPANY_SETTING_HAS_SUPPLIER',
  GET_TEMPLATE_DETAIL_FOR_REPORT: 'GET_TEMPLATE_DETAIL_FOR_REPORT',
  GET_AUDIT_RATING_TITLES_SETTING: 'GET_AUDIT_RATING_TITLES_SETTING',
  GET_COMPANY_SETTING_MEASUREMENT_AQL: 'GET_COMPANY_SETTING_MEASUREMENT_AQL',
  GET_AQL_LIST: 'GET_AQL_LIST',
}

export const COLOR_SIZE_SEPARATOR_KEY = '~color-size~'

export const COLOR_SIZE_SEPARATOR_KEY_LENGTH = COLOR_SIZE_SEPARATOR_KEY.length
